/**
 * One of `allowed`, or the fallback — for a value read from the URL.
 *
 * Guarded lookup, never a cast: a hand-edited URL must not put an unknown
 * value into the request.
 */
export function parseEnum<T extends string>(
  raw: string | null,
  allowed: readonly T[],
  fallback: T,
): T {
  return allowed.find((option) => option === raw) ?? fallback;
}
